import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GeneratorCountryZoneCountryModel, GeneratorCountryZoneModel } from '@/Models';
import { CountryCode } from '@/Enums';
import { countryZoneUtils } from './utils';
import { asyncActions } from './asyncActions';

export type GeneratorCountryZoneState = {
  countryZones: GeneratorCountryZoneCountryModel[];
  selectedUuid: string;
  selectedCountryCode: CountryCode | null;
};

const initialState: GeneratorCountryZoneState = {
  countryZones: [],
  selectedUuid: '',
  selectedCountryCode: null,
};

const generationProductsSlice = createSlice({
  name: 'generatorCountryZonesState',
  initialState,
  reducers: {
    setSelectedUuid(state, action: PayloadAction<string>) {
      state.selectedUuid = action.payload;
    },
    setSelectedCountryCode: (state, action: PayloadAction<CountryCode>) => {
      state.selectedCountryCode = action.payload;
    },
    addCountryZone(state, action: PayloadAction<GeneratorCountryZoneModel>) {
      countryZoneUtils.addZone(state.countryZones, action.payload);
    },
    deleteCountryZone(state, action: PayloadAction<GeneratorCountryZoneModel>) {
      countryZoneUtils.deleteZone(state.countryZones, action.payload.id);
    },
    clearData(state) {
      state.countryZones = [];
      state.selectedUuid = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(asyncActions.getGeneratorCountryZonesRequest.fulfilled, (state, action) => {
        state.countryZones = action.payload.countryZones;
      })
      .addCase(asyncActions.createGeneratorCountryZoneRequest.fulfilled, (state, action) => {
        countryZoneUtils.updateZone(state.countryZones, action.payload.countryZone, state.selectedUuid);
        state.selectedUuid = '';
      })
      .addCase(asyncActions.updateGeneratorCountryZoneRequest.fulfilled, (state, action) => {
        countryZoneUtils.updateZone(state.countryZones, action.payload.countryZone);
        state.selectedUuid = '';
      })
      .addCase(asyncActions.deleteGeneratorCountryZoneRequest.fulfilled, (state, action) => {
        countryZoneUtils.deleteZone(state.countryZones, action.payload);
        state.selectedUuid = '';
      });
  },
});

const { actions, reducer } = generationProductsSlice;

export const generatorCountryZonesActions = actions;
export const generatorCountryZonesReducer = reducer;
export const generatorCountryZonesAsyncActions = asyncActions;
